import Register from "../components/Login/Register";
import background from "./background.jpg";

export default function RegisterPage() {
  return (
    <div style={{ backgroundImage: `url(${background})` }}>
      <Register />
    </div>
  );
}
